import { Button, Checkbox, Grid } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert'
import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { authContext } from '../../context/AuthContext'
import { GridAutoTextField } from '../helper/GridComponents'
import Loading from '../helper/Loading'
import PageHeader from '../helper/PageHeader'
import styles from '../styles'

const rolesMap = {
    admin: {
        isRoleAdmin: 1,
        isUserAdmin: 1,
        isOnlineTrainingAdmin: 1,
        isOnlineTrainingEditor: 1,
        isClassroomTrainingAdmin: 1,
        isClassroomTrainingManager: 1,
        isProgramCoordinator: 1,
        isTrainingCouponAdmin: 1,
        isInstructorAdministrator: 1,
    },
    customerService: {
        isClassroomTrainingManager: 1,
        isUserAdmin: 1,
        isOnlineTrainingAdmin: 1,
        isTrainingCouponAdmin: 1,
    },
    coordinator: {
        isClassroomTrainingManager: 1,
        isProgramCoordinator: 1,
        isInstructorAdministrator: 1,
    }
}

const options = [
    { label: "Administrator", value: rolesMap.admin }, //"admin" },
    { label: "Customer Service", value: rolesMap.customerService }, //"customerService" },
    { label: "Coordinator", value: rolesMap.coordinator }, //"coordinator" },

]

const permissionsMap = [
    { value: "isRoleAdmin", title: "Manage User Permissions", detail: "Manage user permissions" },
    { value: "isUserAdmin", title: "Manage users", detail: "Manage user profiles, reset user's passwords, view profile change logs." },
    //{ value: "", title: "System Administrator", detail: "" }, //obsolete
    { value: "isOnlineTrainingAdmin", title: "Manage online training records", detail: "View all online training reports - student module progress and tests, purchases and coupon reports.  Disregard/delete tests and enter test scores from paper tests (Note: new system should not allow deleting tests but should allow transferring them to different account)" },
    { value: "isOnlineTrainingEditor", title: "Manage online training settings", detail: "Manage online training courses general information / settings" },
    { value: "isClassroomTrainingAdmin", title: "Manage Classroom Option Lists", detail: "Manage the option lists used in classroom training including location template, contact template, regions, organization, category." },
    //{ value: isClassroomTrainingCreator", title: "Classroom Training Creator", detail: "" }, //not used
    { value: "isClassroomTrainingManager", title: "Manage classes", detail: "Edit classes created by other users" },
    //{ value: "", title: "Classroom Training Registration Administrator", detail: "" }, //obsolete
    { value: "isProgramCoordinator", title: "Approve classes", detail: "Approve (publish) classes added late or with higher cost" },
    { value: "isTrainingCouponAdmin", title: "Manage user purchases", detail: "Create free coupons [new system - add free credit & also remove credit or training after or account transfer]" }, //obsolete
    { value: "isInstructorAdministrator", title: "Manage instructors", detail: "Add/Edit Instructors [+ for new system Add/Edit Training provider organizations (not well defined yet)]" },
    //{ value: isInstructorResourcesUser", title: "Instructor Resources User", detail: "" }, //not used
]

const clearedPermissions = {
    isCertifiedInstructor: 0, // not used
    isClassroomTrainingAdmin: 0,
    //isClassroomTrainingCreator: 0,
    isClassroomTrainingManager: 0,
    isInstructorAdministrator: 0,
    //isInstructorResourcesUser: 0,
    isOnlineTrainingAdmin: 0,
    isOnlineTrainingEditor: 0,
    isProgramCoordinator: 0,
    isRoleAdmin: 0,
    isTrainingCouponAdmin: 0,
    isUserAdmin: 0,
}

const AdminRolesUpdate = props => {
    const { username } = props.match.params //route params
    const { classes } = props

    const history = useHistory()
    const user = useContext(authContext)

    const [permissions, setPermissions] = useState(clearedPermissions)
    const [loadedPermissions, setLoadedPermissions] = useState(null) // for the revert changes button
    const [template, setTemplate] = useState(null) //uses autocomplete and options
    const [loading, setLoading] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const mounted = useRef(true)

    useEffect(() => {
        async function getPermissions() {
              // grabs permissions, sets the state if mounted
            setLoading(true)
            const res = await axios.get("/api/user/permissions/" + username)

            if (mounted.current) {
                // grab the first 100
                const data = res.data
                console.log(data)
                setPermissions(data.permissions)
                setLoadedPermissions(data.permissions)
                setLoading(false)
            }
        }        
        getPermissions();
        // on unmount
        return () => mounted.current = false
    },[username])


    // sends to backend
    const onSave = async () => {
        setLoading(true);
        console.log(user.user);
        let data = {
            byUsername: user.user.username,
            permissions: permissions
        }
        const res = await axios.post("/api/user/permissions/" + username, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: user.accessToken
            }
        })
        console.log(res)
        if (mounted.current) {
            setLoading(false)

            if (res.status === 200)
                setShowAlert(true)
        }
    }

    // check a checkbox
    const handleCheck = (event, value) => {
        event.persist()
        setPermissions(prev => ({
            ...prev,
            [event.target.name]: value ? 1 : 0
        }))
    }

    // set the template value, and load the checkboxes for that template
    const handleTemplate = (event, value) => {
        setTemplate(event.target.value)

        const loadedPerm = event.target.value && event.target.value.value
        const newPermissions = { ...clearedPermissions, ...loadedPerm }
        setPermissions(newPermissions)
    }

    // when the button is clicked, clear all the checkboxes as well as the template
    const revertChanges = () => {
        setPermissions(loadedPermissions)
        setTemplate(null)
    }

    return (
        <>
            <PageHeader
                title={"Permissions: " + username}
                cancel={history.goBack}
            />
            {showAlert && <><Alert severity="success" onClose={() => setShowAlert(false)} >Permissions Successfully Updated</Alert><br /></>}

            {loading ? <Loading /> :
                <>
                    <Grid container spacing={3}>
                        <GridAutoTextField
                            xs={12}
                            sm={8}
                            md={6}
                            name="template"
                            options={options}
                            value={template}
                            onChange={handleTemplate}
                            classes={classes}
                            label="Predefined Roles"
                        />
                        <Grid item xs={12} sm={4} md={6}>
                            <Button variant="outlined" color="primary" className={[].join(' ')} onClick={revertChanges} >Revert Changes</Button>
                        </Grid>
                    </Grid>
                    <br />
                    <br />
                    {permissionsMap.map((perm) =>
                        <div key={perm.value}>
                            <Checkbox color="primary" name={perm.value} checked={permissions[perm.value] === 1} onChange={handleCheck} />
                            <span style={{ fontWeight: 'bold' }}>{perm.title}</span><span>{" - " + perm.detail}</span>
                        </div>
                    )}
                    <br />
                    <br />
                    <Button variant="contained" color="primary" type="submit" className={[].join(' ')} onClick={onSave} >Save</Button>
                </>
            }
        </>
    )
}


export default withStyles(styles, { withTheme: true })(AdminRolesUpdate);